<app-breadcrumb [master]="'Kadry'" [parentName]="'Wnioski urlopowe'" [name]="'Szczegóły'"></app-breadcrumb>
<mat-tab-group >
  <mat-tab label="Dane">
    <app-leave-application-details-view *ngIf="!modify" [leaveApplication]="leaveApplicationObject"  (changed)="loadLeaveApplication()" (modifyClicked)="modify = true">    </app-leave-application-details-view>
    <app-leave-application-edit *ngIf="modify" [leaveApplication]="leaveApplication" (closeModification)="modify = false; loadLeaveApplication()" ></app-leave-application-edit>

  </mat-tab>
    <mat-tab label="Historia zmian">
      <ng-template matTabContent>
        <app-log-list  [leaveApplication]="leaveApplication"></app-log-list>
      </ng-template>
    </mat-tab>
</mat-tab-group>

